
import { httpClient, setResponseType } from '@/app/shared/services';
import { apiConstants } from '../config';

import { PRODUCT_STORE, BASE_API } from '@/config';

const URL = apiConstants.product;

// PRODUCTOS
const PRODUCT_TYPES = [
  { key: 'pre_paid', value: 'parkings_plans_clients', label: 'Planes Prepago', element: 'Plan Prepago'},
  { key: 'base', value: 'parkings_plans_clients_per_minutes', label: 'Planes Base (por minuto)', element: 'Plan Base'},
  { key: 'custom',  value: 'parkings_plans_clients_customs', label: 'Planes Personalizados', element: 'Plan Personalizados'},
  { key: 'trial', value: 'parkings_plans_clients_trials', label: 'Períodos de prueba', element: 'Período de Prueba'},
]


const fetchAllProductsStatusActive = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.post(`${URL}/status/active?page=${page}${filter}`, {}).then(res => res.data)
  }
  else {
    return httpClient.post(`${URL}/status/active?${filter}`, {}).then(res => res.data)
  }
};

const fetchAllProductsStatusFinished = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.post(`${URL}/status/finished?page=${page}${filter}`, {}).then(res => res.data)
  }
  else {
    return httpClient.post(`${URL}/status/finished?${filter}`, {}).then(res => res.data)
  }
};


const fetchAllProductsStatusNotActive = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.post(`${URL}/status/notActive?page=${page}${filter}`, {}).then(res => res.data)
  }
  else {
    return httpClient.post(`${URL}/status/notActive?${filter}`, {}).then(res => res.data)
  }
};

/*
| Category | Endpoint | Condition |
|----------|----------|-----------|
| **Active** | `GET /api/client/products/v2/active` | Current time is between `start_datetime` and `end_datetime`, AND plan passes `isActivePlan()` check |
| **Upcoming** | `GET /api/client/products/v2/upcoming` | `start_datetime` > now (plan hasn't started yet) |
| **Finished** | `GET /api/client/products/v2/finished` | `end_datetime` < now (plan has ended) |
*/

const fetchAllProductsActive = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";
  return httpClient.get(`${URL}/active?${filter}`).then(res => res.data)
};

const fetchAllProductsNotActive = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";
  return httpClient.get(`${URL}/notActive?${filter}`).then(res => res.data)
};

const fetchAllProductsFinished = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";
  return httpClient.get(`${URL}/finished?${filter}`).then(res => res.data)
};

/*****/

const fetchOneProduct = (id, productType = 'prepago') => {
  // ['prepago','custom']
  return httpClient.get(`${URL}/detail/${productType}/${id}`).then(res => res);
};

const checkProductDates = (dataProduct) => {
  return httpClient.post(`${URL}/generate-product-order`,  dataProduct).then(res => res.data);
};

const payProduct = (dataProduct) => {
  return httpClient.post(`${URL}/pay`,  dataProduct).then(res => res.data);
}

const getProductByToken = (product_type, token) => {
  // parkings-plans-clients-customs/{token}
  // parkings-plans-clients-extras/{token}
  // product_type = EXTRA / CUSTOM

  const type = `${product_type.toLowerCase()}s`;

  return httpClient.get(`${BASE_API}/parkings-plans-clients-${type}/${token}`).then(res => res.data);
}

const securePayProduct = ( product_type, product_id ) => {

  // 'PC' => 'PC000', // pay Custom
  // 'PE' => 'PE000', // pay Extra
  // product_type = EXTRA / CUSTOM

  // parkings-plans-clients-customs/secure-payment/{id}
  // parkings-plans-clients-customs/secure-payment/{id}

  const type = `${product_type.toLowerCase()}s`;

  return httpClient.post(`${BASE_API}/parkings-plans-clients-${type}/secure-payment/${product_id}`).then(res => res.data);

  // return httpClient.post(`${URL}/clients/secure-payment/${clients_id}`, { product_type, product_id }).then(res => res.data);
}

const updateProduct = ({id, renewal, product_type}) => {

  const dataProduct = { id, renewal, product_type };

  // return new Promise((resolve) => {
  //   resolve({
  //     status: 'success',
  //     data: dataProduct
  //   });
  // });

  // return httpClient.put(`${URL}/${product_type}/update-renewal`,  dataProduct).then(res => res.data);
  // * Por ahora solo planes mensuales
  return httpClient.put(`${URL}/prepago/update-renewal`,  dataProduct).then(res => res.data);
}


const downloadExcel = (filename, model = null ) => {
  setResponseType('blob');
  return httpClient.post(`${model}/to-excel`, {name: filename}).then(res => {
    setResponseType('json');
    return res
  });
};


const resetResponseType = () => {
  setResponseType('json');
};



export const setProductStore = (ProductApi) => {
  return localStorage.setItem(PRODUCT_STORE, JSON.stringify({ ...ProductApi}));
}

export const getProductStore = () => {
  return JSON.parse(localStorage.getItem(PRODUCT_STORE));
}

export const removeProductStore = () => {
  return localStorage.removeItem(PRODUCT_STORE);
}


export {
  downloadExcel,
  resetResponseType,
  fetchAllProductsActive,
  fetchAllProductsNotActive,
  fetchAllProductsFinished,
  fetchOneProduct,
  checkProductDates,
  payProduct,
  updateProduct,
  getProductByToken,
  securePayProduct,

  fetchAllProductsStatusActive,
  fetchAllProductsStatusFinished,
  fetchAllProductsStatusNotActive,
};
